export default function LabelText(props: any) {
  return <span className={`font-bold mb-4 ${props.className}`}>{props.children}</span>
}
